import { InputFieldType } from '@vfde-brix/core';
import { NUMBER_OF_BUSINESS_UNIT_ID, NUMBER_OF_RESIDENCE_ID, REPRESENTED_BY_CHECKBOX_ID } from '../constant';

/** Checks if one of the two input fields are filled with a number greater than 0 */
const isResidentialOrBusinessUnitValid = (): boolean => {
    const numberOfBusinessUnitInput = document.getElementById(NUMBER_OF_BUSINESS_UNIT_ID) as HTMLInputElement;
    const numberOfResidenceInput = document.getElementById(NUMBER_OF_RESIDENCE_ID) as HTMLInputElement;

    if (!numberOfResidenceInput.value && !numberOfBusinessUnitInput.value) {
        return false;
    }

    if (+numberOfResidenceInput.value > 0) {
        return true;
    }

    if (+numberOfBusinessUnitInput.value > 0) {
        return true;
    }

    return false;
};

/** Returns if the represented by checkox is checked or not */
const isRepresentedByChecked = (): boolean => {
    const representedByCheckBox = document.getElementById(REPRESENTED_BY_CHECKBOX_ID) as HTMLInputElement;

    return representedByCheckBox.checked;
};

/** Required validator for the input fields present in the Represented by section */
const validateRepresentedByInput = (inputFields: InputFieldType[]): boolean => {

    // validate only if the checkbox is checked
    if (!isRepresentedByChecked()) {
        return true;
    }

    // validate regular inputs
    if (inputFields.length == 1) {
        return !!inputFields[0].value;
    }

    // option selectors have multiple inputs, one has to be selected
    for (const input of inputFields) {
        if (input.value) {
            return true;
        }
    }

    return false;
};

export { isResidentialOrBusinessUnitValid, validateRepresentedByInput };
